export const makeParagraph = (content: string, ...rest: string[]): string => {
  return content + rest.join(' ');
};
